import { render, staticRenderFns } from "./SubscribedBadgeIcon.vue?vue&type=template&id=4193faa0"
import script from "./SubscribedBadgeIcon.vue?vue&type=script&lang=js"
export * from "./SubscribedBadgeIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports